<script setup>
import WindlistPage from '@/components/WindlistPage.vue';

</script>

<template>
  <Suspense>
    <WindlistPage />
  </Suspense>
</template>
